<div class="loading">
	<span class="dot"></span>
	<span class="dot"></span>
	<span class="dot"></span>
</div>
